var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 7.13848C2.33337 5.93566 2.33337 5.33425 2.63207 4.85095C2.93077 4.36764 3.46869 4.09868 4.54452 3.56077L5.21119 3.22743C6.089 2.78853 6.52791 2.56908 7.00004 2.56908C7.47218 2.56908 7.91108 2.78853 8.7889 3.22744L9.45556 3.56077C10.5314 4.09868 11.0693 4.36764 11.368 4.85095C11.6667 5.33425 11.6667 5.93566 11.6667 7.13848V7.66634C11.6667 9.55196 11.6667 10.4948 11.0809 11.0806C10.4951 11.6663 9.55233 11.6663 7.66671 11.6663H6.33337C4.44776 11.6663 3.50495 11.6663 2.91916 11.0806C2.33337 10.4948 2.33337 9.55196 2.33337 7.66634V7.13848Z",
    stroke: "#6D6E82",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49759 7.58121L2.33337 6.41699V9.66699C2.33337 10.7716 3.2288 11.667 4.33337 11.667H9.66671C10.7713 11.667 11.6667 10.7716 11.6667 9.66699V6.41699L10.5025 7.58121C10.1274 7.95628 9.61871 8.16699 9.08828 8.16699H4.9118C4.38137 8.16699 3.87266 7.95628 3.49759 7.58121Z",
    fill: "white",
    stroke: "#6D6E82",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailListIcon);
export default __webpack_public_path__ + "static/media/email-list-icon.c5cf93307ab5a3cd3381baf7d78e5ecf.svg";
export { ForwardRef as ReactComponent };